import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { ScreensLGPDForm } from '../LGPD/Form';
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ServiceConfig } from './../../service/Config';

class ScreensLoginForm extends Component {

    constructor() {

        super();

        this.state = {
            splash: false,
            isLicense: false,
            objLGPD: { Usuario: '', Exibir: false, Perfil: "" },
            isLicense: false
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';

        this.serviceLogin = new ServiceLogin();
        this.serviceConfig = new ServiceConfig();
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();

    }

    componentDidMount() {
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();
    }

    getDadosUsuario(data) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: 'Medico',
                DadosAcesso: ''
            }
        }
    }

    async handleConfig() {
        const response = await this.serviceConfig.GetConfig();
        if (response) {
            const config = Object.fromEntries(response.map(obj => [obj.Key, obj.Value]));
            const objConfig = {};

            if (config['NOME_BOTAO_IMPRIMIR_PORTAL']) {
                objConfig.NomeBotaoImprimirPortal = config['NOME_BOTAO_IMPRIMIR_PORTAL'];
            }

            if (config['23']) {
                objConfig['23'] = JSON.parse(config['23']);
            }

            sessionStorage.setItem('config', JSON.stringify(objConfig));

            return objConfig;
        }
    }

    async handleLogin(payload) {
        try {
            const response = await this.serviceLogin.login(payload.usuario, payload.senha)
            if (response) {
                const config = await this.handleConfig();
                const isLicense = config['23'];

                if (this.aceiteLGPD === false) {
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true } });
                }

                if (isLicense) {
                    this.setState({ isLicense: isLicense });
                }

                if (!isLicense) {
                    window.location = "#/portal";
                }
            }
        } catch (err) {
            ServiceMessage.warn('Usuário ou senha inválidos!');
        } finally {
            this.setState({ splash: false });
        };
    }

    handleExecute(e) {

        if (e.usuario === "")
            return ServiceMessage.warn('Preencha o campo Login.');

        if (e.senha === "")
            return ServiceMessage.warn('Preencha o campo Senha.');

        this.setState({ splash: true });

        this.handleLogin(e);
    }

    render() {

        return (
            <div>
                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)}
                    exibirTipo={true}
                    isLicense={this.state.isLicense}
                    perfil=""
                ></ComponentsLoginForm>
            </div>
        );

    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ actionsLogin }, dispatch);

const mapStateToProps = store => ({
    login: store.stateLogin.login,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreensLoginForm);